import { filter, pairwise } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../shared/services/security/auth.service';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
  previousUrl: string;
  getURL: string;
  isModeMaintenance: boolean;
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        
        if (events[0].urlAfterRedirects !== '/auth/login') {
          this.authService.setUrl(events[0].urlAfterRedirects);
        }
        if (events[0].urlAfterRedirects === '/auth/logout') {
          this.authService.setUrl('');
        }
      });
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.canShow()) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.canShow()) {
      return true;
    }

    this.router.navigate(['/auth/login']);
    return false;
  }

  canShow(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isModeMaintenance){
      return false;
    }
    if (!this.authService.isTokenExpired() && this.authService.getUser()) {
      return true;
    }



    // if (this.router.url !== '/auth/login' && this.router.url !== '/' && this.router.url !== '/auth/logout') {
    //   this.authService.logout();
    //   this.toastService.showToastJWTExpired('error', 'JWT expired', 'Token JWT expired, redirect to login.');
    //   this.router.navigate(['/auth/login']);
    // }

    return false;
  }

}
